import React from "react";
import {
  BiCreditCard,
  BiFileBlank,
  BiCar,
  BiUserVoice,
} from "react-icons/bi";
import { BsWhatsapp } from "react-icons/bs";
import { TbMail } from "react-icons/tb";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import { Link } from "react-router-dom";
import { Fade, Zoom } from "react-awesome-reveal";
import Container from "./styled";

const WHATSAPP_URL =
  "https://api.whatsapp.com/send?phone=5491133602103&text=%C2%A1Hola,%20necesito%20atención%20de%20SeguroBici!%20Ingresé%20desde%20la%20web.";

const formatEmailDisplay = (email) => {
  const atIndex = email.indexOf("@");
  if (atIndex === -1) return email;

  return (
    <>
      {email.slice(0, atIndex + 1)}
      <wbr />
      {email.slice(atIndex + 1)}
    </>
  );
};

const AREAS = [
  {
    id: "cobranza",
    title: "Cobranza",
    description: "Registrá pagos, consultá cuotas y gestioná tus cobros.",
    icon: BiCreditCard,
    email: "cobranzas@seguroweb.com.ar",
    accent: "cobranza",
  },
  {
    id: "emision",
    title: "Emisión",
    description: "Solicitá y gestioná tus emisiones de forma rápida y segura.",
    icon: BiFileBlank,
    email: "emision@seguroweb.com.ar",
    accent: "emision",
  },
  {
    id: "siniestro",
    title: "Siniestro",
    description: "Reportá siniestros, hacé seguimiento y recibí asistencia.",
    icon: BiCar,
    email: "siniestros@seguroweb.com.ar",
    accent: "siniestro",
  },
  {
    id: "comercial",
    title: "Comercial",
    description:
      "Consultas, asesoramiento y todo lo que necesitás para crecer juntos.",
    icon: BiUserVoice,
    email: "info@seguroweb.com.ar",
    accent: "comercial",
  },
];

export default function Canales() {
  return (
    <Container>
      <section id="max-width-container">
        <Fade delay={80} duration={700} triggerOnce className="fade-container">
          <div className="novedad-wrapper">
            <div className="corner-ribbon">
              <span>
                <strong>¡Todo en un solo WhatsApp!</strong>
              </span>
            </div>
            <span className="deco-blob deco-blob--1" aria-hidden="true" />
            <span className="deco-blob deco-blob--2" aria-hidden="true" />

            <Link to="/contacto" className="badge-unificado">
              <HiOutlineSpeakerphone />
              <p>
                <span>¡Nuevo!</span> Contacto
              </p>
            </Link>

            <div className="title-container">
              <h3>
                ¡Lanzamos nuestro nuevo servicio de{" "}
                <span>atención integral!</span>
              </h3>
            </div>

            <div className="text-container">
              <p>
                Todas tus consultas, trámites y gestiones en un solo lugar. Más
                simple, más rápido, más cerca de vos.
              </p>
            </div>

            <div className="areas-convergence">
              <div className="areas-grid">
                {AREAS.map(
                  (
                    { id, title, description, icon: Icon, email, accent },
                    index
                  ) => (
                    <Fade
                      key={id}
                      delay={120 + index * 80}
                      duration={600}
                      triggerOnce
                      className="area-card-wrapper"
                    >
                      <div className={`area-card area-card--${accent}`}>
                        <div className="area-card__icon">
                          <Icon />
                        </div>
                        <h4>{title}</h4>
                        <p className="area-card__description">{description}</p>
                        <a className="area-card__email" href={`mailto:${email}`}>
                          <TbMail />
                          <span className="area-card__email-text">
                            {formatEmailDisplay(email)}
                          </span>
                        </a>
                      </div>
                    </Fade>
                  )
                )}
              </div>

              <div className="arrows-convergence" aria-hidden="true">
                <svg
                  className="convergence-svg"
                  viewBox="0 0 800 155"
                  preserveAspectRatio="none"
                >
                  <path
                    className="arrow-path arrow-path--cobranza"
                    d="M94,0 C94,55 230,88 400,98"
                    fill="none"
                    strokeWidth="2.5"
                  />
                  <path
                    className="arrow-path arrow-path--emision"
                    d="M298,0 C298,48 338,90 400,98"
                    fill="none"
                    strokeWidth="2.5"
                  />
                  <path
                    className="arrow-path arrow-path--siniestro"
                    d="M502,0 C502,48 462,90 400,98"
                    fill="none"
                    strokeWidth="2.5"
                  />
                  <path
                    className="arrow-path arrow-path--comercial"
                    d="M706,0 C706,55 570,88 400,98"
                    fill="none"
                    strokeWidth="2.5"
                  />
                  <path
                    className="arrow-drop"
                    d="M400,98 C400,112 400,124 400,138"
                    fill="none"
                    strokeWidth="2.5"
                  />
                  <circle className="arrow-dot arrow-dot--cobranza" cx="94" cy="0" r="4" />
                  <circle className="arrow-dot arrow-dot--emision" cx="298" cy="0" r="4" />
                  <circle className="arrow-dot arrow-dot--siniestro" cx="502" cy="0" r="4" />
                  <circle className="arrow-dot arrow-dot--comercial" cx="706" cy="0" r="4" />
                  <polygon
                    className="arrow-head"
                    points="400,148 392,136 408,136"
                  />
                </svg>
              </div>

              <Zoom delay={500} duration={500} triggerOnce>
                <div className="whatsapp-hub">
                  <a
                    className="whatsapp-cta"
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="whatsapp-pulse" aria-hidden="true" />
                    <BsWhatsapp />
                    ¡Atención personalizada a solo un clic!
                  </a>
                </div>
              </Zoom>
            </div>

            <div className="footer-info">
              <p className="subtitle-text">
                Nuestro horario de atención es de 9hs a 18hs todos los días
                hábiles
              </p>
              <p className="second-text">
                También podés comunicarte a través de nuestra página de contacto
              </p>
            </div>
          </div>
        </Fade>
      </section>
    </Container>
  );
}
